import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import "../../styles/Login.css";
import { useEffect } from "react";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://ecom-api.applligentdemo.com/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok && data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("isAuthenticated", "true");

        const role = data.user.role || data.role;
        console.log(role);

        if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        } else {
          console.warn("No user returned in login response");
        }
        console.log("Login success");
        navigate("/dashboard");
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };
    useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, []);
  return (
    <div className="login-page">
      <div className="login-box">
        <h2 className="text-center mb-4">User Login</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleLogin}>
          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Form.Label>Email address</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Form.Label>Password</Form.Label>
          </Form.Group>

          <Button
            variant="dark"
            type="submit"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </Button>
        </Form>

        <div className="text-center mt-3">
          If you have forgot your{" "}
          <a href="/forget-password">Forgot Password?</a>
        </div>
        <div className="text-center mt-3">
          If you are new <a href="/register">user register?</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
